import React from 'react';
import { Input, Button, Space, TreeSelect, Skeleton } from 'antd';
import Card from '../com/partTimeJob/card';
import Config from "../../config/Config";
import EventBus from "../../frame/eventBus";
import WidgetAjax from '../../widget/WidgetAjax';
import { checkLogin } from '../../pages/com/utils';
import { CaretDownOutlined } from '@ant-design/icons';
import NoData from '../com/NoData';
import JobInfo from '../recommendedJob/JobInfo';
import JobTable from '../com/job/scrollCardTable';
import HeaderSearch from "./com/HeaderSearch";
import CustomSelect from '../com/select/CustomLabelSelect';
let path = Config.getBasePath();
let filePath = Config.getFilePath();
class partTimeSearch extends React.Component {
  constructor(props) {
    super(props);
    this.HeaderSearchRef = React.createRef();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    let word = params.get('word') || undefined;
    let PROPERTY = params.get('PROPERTY') || undefined;
    let WORKPLACE = params.get('WORKPLACE') || undefined;
    let JOBTYPE = params.get('JOBTYPE') || undefined;
    if (PROPERTY) {
      PROPERTY = PROPERTY.split(",");
    }
    if (WORKPLACE) WORKPLACE = [WORKPLACE]
    if (JOBTYPE) JOBTYPE = [JOBTYPE]
    let location = JSON.parse(sessionStorage.getItem("_user_location_"));
    this.state = {

      filterEntity: [
        { options: 'occupationData', value: 'JOBTYPE', label: '职位类型', mode: 'tree' },
        { options: 'eduData', value: 'REQEDU', label: '学历要求', mode: 'multiple' },
        { options: 'expData', value: 'REQWE', label: '经验要求', mode: 'single' },
      ],
      filterLoading: true,
      conditionList: [
        { label: '区域', props: 'DISTRICT', options: [], valueProps: "code" },
        { label: '工作方式', props: 'WORKPLACE', options: [], valueProps: "value" },
        { label: '结算', props: 'SALCYC', options: [], valueProps: "value" },
        { label: '时间', props: 'WORKTIME', options: [], valueProps: "value" },
      ],
      filter: {
        DISTRICT: location && location.value ? [location?.value] : ["100000"],
        JOBTYPE,
        word,
        PROPERTY,
        WORKPLACE,
        PROPERTY:['12','13']
      },
      occupationData: [],
      location: location || undefined,
      infoLoading: false,
      jobInfo: {},
      check_jobId: null,
      word: word || undefined,
      eduData: [],
      expData: []
    };

  }

  componentDidMount() {
    this.occupation();
    this.loadDimensions();
    this.eduDimension();
    this.WORKEXP();
    let scroll = document.querySelector('.sf-body')?.addEventListener('scroll', this.handleScroll);
    EventBus.on('locationChange', this.locationChange);
  }

  componentWillUnmount() {
    let scroll = document.querySelector('.sf-body')?.removeEventListener('scroll', this.handleWindowScroll);
    EventBus.off('locationChange', this.locationChange);
  }

  locationChange = async (location) => {
    const { filter } = this.state;
    await this.setState({
      location,
      jobData: [],
      page: 1,
      filter: {
        ...filter, DISTRICT: location?.value ? [location?.value] : ["100000"]
      }
    });
    this.loadDimensions();
  }


  handleScroll = () => {
    const scrollContainer = document.querySelector('.sf-body');
    if (scrollContainer) {
      const scrollTop = scrollContainer.scrollTop;
      if (scrollTop > 228) {
        this.setState({ fixedCon: true })
      } else {
        this.setState({ fixedCon: false })
      }
    }
  };


  dataBuild = (data) => {
    let arr = []
    data.map((item) => {
      let datas = {};
      if (item.name != '全部') {
        datas['label'] = item.name;
        datas['value'] = item.value || item.code;
        if (item.child) {
          let child = this.dataBuild(item.child.values);
          datas['children'] = child;
        }
        if (item.children) {
          let child = this.dataBuild(item.children);
          datas['children'] = child;
        }
        arr.push(datas)
      }

    })
    return arr
  }


  //职位类型
  occupation = () => {
    let params = { parent_code: "0" }
    const onOccupation = (result) => {
      if (result.status === 0) {
        const newArray = result.results.filter(obj => obj.name !== '全部' && obj.name !== '常用岗位')
        let arr = this.dataBuild(newArray);
        this.setState({ occupationData: arr });
      }
    }
    WidgetAjax.ajax({ url: path + `/recruitment/job_type`, params, callback: onOccupation }, this.props);
  }


  /***
   * 学历要求
   */
  eduDimension = () => {
    const eduDimension = (res) => {
      if (res.status == 0 && res.results && res.results.length > 0) {
        let arr = res.results[0].values.map((item) => {
          return { label: item.name, value: item.value }
        })
        this.setState({ eduData: arr })
      }
    }
    WidgetAjax.ajax({ url: path + "/widget/dimension", params: { "dimension": "D424" }, callback: eduDimension });
  }

  /**
   * 经验要求
   */
  WORKEXP = () => {
    const onExp = (res) => {
      if (res.status == 0 && res.results && res.results.length > 0) {
        let arr = res.results[0].values.map((item) => {
          return { label: item.name, value: item.value }
        })
        this.setState({ expData: arr })
      }
    }
    WidgetAjax.ajax({ url: path + "/widget/dimension", params: { "dimension": "D423" }, callback: onExp });
  }

  /**
   * 地区
   */
  areaList = () => {
    const { location } = this.state;
    let params = { hierarchy: "2", parent_code: location?.value || "100000", rank: "4" }
    return new Promise((resolve, reject) => {
      WidgetAjax.ajax({
        url: path + '/recruitment/area',
        params: params,
        callback: (res) => {
          if (res.status == 0) {
            resolve(res);
          } else {
            reject(new Error(res.message || '获取地区失败'));
          }
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  getDimension = (params) => {
    return new Promise((resolve, reject) => {
      WidgetAjax.ajax({
        url: path + '/widget/dimension',
        params: params,
        callback: (res) => {
          if (res.status == 0) {
            resolve(res);
          } else {
            reject(new Error(res.message || '获取维度失败'));
          }
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  async loadDimensions() {
    try {
      const results = await Promise.allSettled([
        this.areaList(),
        this.getDimension({ dimension: "D428" }),
        this.getDimension({ dimension: "D429" }),
        this.getDimension({ dimension: "D430" }),
      ]);

      // 处理结果
      const conditionList = [...this.state.conditionList];

      results.forEach((result, index) => {
        if (result.status === 'fulfilled') {
          const res = result.value;

          if (index === 0 && res.results) {
            conditionList[0].options = res.results;
          } else if (index === 1 && res.results[0]?.values) {
            conditionList[1].options = res.results[0].values;
          }
          else if (index === 2 && res.results[0]?.values) {
            conditionList[2].options = res.results[0].values;
          } else if (index === 3 && res.results[0]?.values) {
            conditionList[3].options = res.results[0].values;


          }
        }
      });

      this.setState({ conditionList, filterLoading: false });
      return results;
    } catch (error) {
      console.error('Error loading dimensions:', error);
      this.setState({ filterLoading: false });
      throw error;
    }
  }

  // 检索
  onSearch = (value) => {
    const { filter, location } = this.state;
    if (value) {
      this.setState({ filter: { ...filter, ...value } });
    } else {
      this.setState({
        filter: {
          DISTRICT: location && location.value ? [location?.value] : ["100000"],
        }
      });
    }

  }

  onInputSearch = () => {
    const { word, filter } = this.state;
    this.setState({ filter: { ...filter, word } });
  }

  onCheck = (value) => {
    this.setState({ check_jobId: value }, () => {
      this.jobInfo(value); // 确保状态更新后再调用
    });
  }

  // 添加 id 参数
  jobInfo = (id) => {
    if (!id) return;

    this.setState({ infoLoading: true });
    const params = { id };

    const onJobInfo = (res) => {
      if (res.status === 0) {
        this.setState({ jobInfo: res.result });
      } else {
        console.error('获取职位信息失败:', res.message);
      }
      this.setState({ infoLoading: false });
    };

    WidgetAjax.ajax({ url: path + '/job/info', params, callback: onJobInfo });
  };

  getJob = (value) => {
    if (!value) {
      this.setState({ infoLoading: false });
    }
  }
  handleSelectChange = async (value, name) => {
    const { filter } = this.state;
    if (name === 'SAL' || name === 'REQAGE'  ) {
      if (value && value.length > 0) {
        this.setState({
          filter: {
            ...filter,
            [name + 'FROM']: value[0].split(",")[0],
            [name + 'TO']: value[0].split(",")[1],
            [name]: value
          }
        });
      } else {
        this.setState({
          filter: {
            ...filter,
            [name + 'FROM']: undefined,
            [name + 'TO']: undefined,
            [name]: []
          }
        });
      }
    } else {
      await this.setState({ filter: { ...filter, [name]: value } });
    }
  };

  render() {
    const { conditionList, filterLoading, filter, filterEntity, infoLoading, jobInfo, fixedCon, word, PROPERTY } = this.state;
    console.log(conditionList, 'conditionList');
    let filter_sel_box = <>
      {
        filterEntity && filterEntity.map((item) => {
          return <CustomSelect
            options={this.state[item?.options]}
            mode={item?.mode}
            value={filter[item?.value]}
            onChange={(value) => this.handleSelectChange(value, item?.value)}
            className="w-full"
            customLabel={item?.label}
          />
        })
      }
    </>
    return (
      <div component-data="partTimeSearch">

        <div className='head_filter'>
          <div className='box_1200 ' >
            <div className='head_filter_box'>
              <div className='search_home'>
                <div className='search_box'>
                  <Space.Compact style={{ width: '100%' }}>
                    <Input placeholder={"搜索关键词"} value={word} onChange={(e) => { this.setState({ word: e.target.value }) }} />
                    <Button type="primary" onClick={() => { this.onInputSearch() }} >搜索</Button>
                  </Space.Compact>
                </div>
              </div>
              <HeaderSearch
                onGetRefHeight={this.HeaderSearchRef}
                conditionList={conditionList}
                onSearch={(value) => this.onSearch(value)}
                loading={filterLoading}
                options={{ labelWidth: 70 }}
                initialValues={filter}
              />
            </div>
          </div>
        </div>
        <div className='box_1200'>

          <div className='mod-select-cont sg-GroupFiltering'>
            {
              filter_sel_box
            }
          </div>
          <div className='mod-fixed-cont sg-GroupFiltering' style={{ display: fixedCon ? "block" : "none" }}>
            {
              filter_sel_box
            }

          </div>


          <div className='job-box'>
            <div className='position-job-container'>
              <JobTable onCheck={this.onCheck} params={filter} onGetJobListCallback={this.getJob} />
            </div>
            <div className='position-job-content'>
              {infoLoading ? (
                <div className='job_info_box' style={{ padding: '20px' }}><Skeleton active /></div>
              ) : jobInfo && jobInfo?.id ? (
                <JobInfo job={jobInfo} onChage={this.jobInfo} />
              ) : (
                <div className='job_info_box' style={{ padding: '20px' }}>  <NoData width={"230px"} height={"230px"} /></div>
              )}
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default partTimeSearch;